/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Alert,
  notification, Radio,
  Select,
  Checkbox,
} from 'antd';
import ProductActions from '@Actions/productActions';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Lottie from 'lottie-react';

import successLottie from '../../../media/lotties/success.json';
import './style.scss';
import PRZSelect from '../../Common/UI/PRZSelect';

const { Option } = Select;

function PrintBarcodes({
  user, printBarcodes, printedBarcodes, printBarcodesLoading, printBarcodesSuccess, barcodeType, selectedRows,
}) {
  const [grnBatchType, setGrnBatchType] = useState('PRODUCT');
  const [pageSize, setPageSize] = useState('4x6');
  const [numberOfCopies, setNumberOfCopies] = useState('1');
  const [numberOfCopiesInput, setNumberOfCopiesInput] = useState('4');
  const [printName, setPrintName] = useState(true);
  const [height, setHeight] = useState(25);
  const [width, setWidth] = useState(50);
  // const [printBarcode, setPrintBarcode] = useState(true);
  const [printBarcodeNumber, setPrintBarcodeNumber] = useState(true);
  const [printMrp, setPrintMrp] = useState(true);
  const [printProductName, setPrintProductName] = useState(true);
  const [printBatchNumber, setPrintBatchNumber] = useState(true);
  const [printInternalSkuCode, setPrintInternalSkuCode] = useState(true);
  const [batchNumberType, setBatchNumberType] = useState('Custom Batch');
  const [showError, setShowError] = useState(false);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const onSubmit = () => {
    setFormSubmitted(true);
    if (printBatchNumber && !batchNumberType) {
      setShowError(true);
      return;
    }
    if (height >= 25 && height <= 100 && width >= 25 && width <= 100) {
      const payload = {
        page_size: pageSize,
        print_batch_name: printName,
        sticker_height: height,
        sticker_width: width,
        print_mrp: printMrp,
        // print_barcode: printBarcode,
        print_barcode_number: printBarcodeNumber,
        print_batch_number: printBatchNumber,
        print_product_name: printProductName,
        print_internal_sku_code: printInternalSkuCode,
        batch_number_type: batchNumberType,
      };
      const products = [];
      if (barcodeType === 'GRN') {
        for (let i = 0; i < selectedRows?.length; i++) {
          if (grnBatchType === 'PRODUCT') {
            products.push({
              product_sku_id: selectedRows[i]?.product_sku_info?.product_sku_id,
              quantity: numberOfCopies === 'Custom' ? numberOfCopiesInput : numberOfCopies,
            });
          } else {
            for (let j = 0; j < selectedRows[i]?.product_batches?.length; j++) {
              products.push({
                batch_id: selectedRows[i]?.product_batches[j]?.batch_id,
                quantity: numberOfCopies === 'Custom' ? numberOfCopiesInput : numberOfCopies,
              });
            }
          }
        }
        if (grnBatchType === 'PRODUCT') {
          payload.product_sku = products;
        } else {
          payload.batches = products;
        }
      } else if (['PRODUCT', 'BATCH'].includes(barcodeType)) {
        for (let i = 0; i < selectedRows?.length; i++) {
          if (barcodeType === 'PRODUCT') {
            products.push({
              product_sku_id: selectedRows[i]?.product_sku_id,
              quantity: numberOfCopies === 'Custom' ? numberOfCopiesInput : numberOfCopies,
            });
          } else {
            products.push({
              batch_id: selectedRows[i]?.batch_id,
              quantity: numberOfCopies === 'Custom' ? numberOfCopiesInput : numberOfCopies,
            });
          }
        }
        if (barcodeType === 'PRODUCT') {
          payload.product_sku = products;
        } else {
          payload.batches = products;
        }
      }
      printBarcodes(payload, (result) => {

      });
    } else {
      notification.open({
        duration: 4,
        message: 'Height and width of the sticker should be between 25-100 mm',
        placement: 'top',
        type: 'warning',
      });
    }
  };

  useEffect(() => {
    printBarcodesSuccess(null);
  }, [selectedRows]);

  const handleRadioChange = (e) => {
    setBatchNumberType(e.target.value);
  };
  return (
    <div className="print-barcode__wrapper">
      <Alert
        message={`You have selected ${selectedRows?.length} ${barcodeType === 'PRODUCT' ? 'products' : 'batches'} for barcode printing.`}
        showIcon
        type="info"
      />
      <div className="ant-row">
        {barcodeType === 'GRN' && (
          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                Print barcodes for products or batches?
              </label>
              <Radio.Group onChange={(e) => setGrnBatchType(e.target.value)} value={grnBatchType}>
                <Radio value="PRODUCT">Product</Radio>
                <Radio value="BATCH">Batch</Radio>
              </Radio.Group>
            </div>
          </div>
        )}
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Select Page Size
            </label>
            <PRZSelect
              value={pageSize}
              disabled={printBarcodesLoading}
              onChange={(value) => {
                setPageSize(value);
              }}
            >
              <Option key="A4" value="A4">A4</Option>
              <Option key="4x6" value="4x6">4x6</Option>
            </PRZSelect>
          </div>
        </div>
        {/* <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              {`Do you want to print ${barcodeType === 'PRODUCT' ? 'product names' : 'batch numbers'} with barcode?`}
            </label>
            <Select
              value={printName ? 'YES' : 'NO'}
              disabled={printBarcodesLoading}
              onChange={(value) => {
                setPrintName(value === 'YES');
              }}
              style={{
                border: '1px solid rgba(68, 130, 218, 0.2)',
                borderRadius: '2px',
                height: '32px',
                width: '100%',
                fontSize: '13px',
              }}
              bordered={false}
            >
              <Option key="YES" value="YES">Yes</Option>
              <Option key="NO" value="NO">No</Option>
            </Select>
          </div>
        </div> */}
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              What should be the dimension of each barcode?
            </label>
            <div className="ant-row">
              <div className="ant-col-md-11">
                <div className="flex-display print-barcode__dimensions">
                  <input
                    name="width"
                    type="number"
                    onChange={(event) => setWidth(event.target.value)}
                    inputClassName=""
                    value={width}
                    maxLength="2"
                    disabled={printBarcodesLoading}
                  />
                  <H3Text text="mm" className="print-barcode__dimensions-unit" />
                </div>
              </div>
              <div className="ant-col-md-2">
                <H3Text text="x" className="print-barcode__dimensions-partition" />
              </div>
              <div className="ant-col-md-11">
                <div className="flex-display print-barcode__dimensions">
                  <input
                    name="width"
                    type="number"
                    onChange={(event) => setHeight(event.target.value)}
                    inputClassName=""
                    value={height}
                    maxLength="2"
                    disabled={printBarcodesLoading}
                  />
                  <H3Text text="mm" className="print-barcode__dimensions-unit" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              How many copies of each barcode do you need?
            </label>
            <PRZSelect
              value={numberOfCopies}
              disabled={printBarcodesLoading}
              onChange={(value) => {
                setNumberOfCopies(value);
              }}
            >
              <Option key="1" value="1">1</Option>
              <Option key="2" value="2">2</Option>
              <Option key="3" value="3">3</Option>
              <Option key="4" value="4">4</Option>
              <Option key="Custom" value="Custom">Custom</Option>
            </PRZSelect>
          </div>
        </div>
        {numberOfCopies === 'Custom' && (
          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                Enter the number of copies you want to print
              </label>
              <input
                name="width"
                type="number"
                onChange={(event) => setNumberOfCopiesInput(event.target.value)}
                inputClassName=""
                value={numberOfCopiesInput}
                maxLength="2"
                disabled={printBarcodesLoading}
              />
            </div>
          </div>
        )}
        {(barcodeType === 'BATCH') && (
          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                Select the batch number that you want to print?
                {' '}
                {printBatchNumber && <span style={{ color: 'red' }}>{'  *'}</span>}
              </label>
              <PRZSelect
                value={batchNumberType}
                disabled={printBarcodesLoading || !printBatchNumber}
                onChange={(value) => {
                  setBatchNumberType(value);
                }}
                showError={showError}
                errorName="Please select batch number that you want to print"
                errorClassName="input-error"
              >
                <Option key="1" value="Custom Batch">Custom Batch Number</Option>
                <Option key="2" value="System Generated Batch">System Generated Batch Number</Option>
              </PRZSelect>
            </div>
          </div>
        )}
        {/*         <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <Checkbox
              checked={printBarcode}
              disabled
              onChange={() => setPrintBarcode(!printBarcode)}
            >
              Print Barcode
            </Checkbox>
          </div>
        </div> */}
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <Checkbox
              checked={printBarcodeNumber}
              disabled={printBarcodesLoading}
              onChange={() => setPrintBarcodeNumber(!printBarcodeNumber)}
            >
              Print Barcode Number
            </Checkbox>
          </div>
        </div>
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <Checkbox
              checked={printInternalSkuCode}
              disabled={printBarcodesLoading}
              onChange={() => setPrintInternalSkuCode(!printInternalSkuCode)}
            >
              Print Internal Sku Code
            </Checkbox>
          </div>
        </div>
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <Checkbox
              checked={printProductName}
              disabled={printBarcodesLoading}
              onChange={() => setPrintProductName(!printProductName)}
            >
              Print Product Name
            </Checkbox>
          </div>
        </div>
        {barcodeType === 'BATCH' && (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="ant-col-md-24">
              <div className="orgInputContainer">
                <Checkbox
                  checked={printBatchNumber}
                  disabled={printBarcodesLoading}
                  onChange={() => {
                    if (printBatchNumber) setBatchNumberType('');
                    setPrintBatchNumber(!printBatchNumber);
                  }}
                >
                  Print Batch Number
                </Checkbox>
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="orgInputContainer">
                <Checkbox
                  checked={printMrp}
                  disabled={printBarcodesLoading}
                  onChange={() => setPrintMrp(!printMrp)}
                >
                  Print Mrp
                </Checkbox>
              </div>
            </div>
          </div>
        )}
      </div>
      {printedBarcodes && (
        <div className="print-barcode__success">
          <div className="print-barcode__success-image">
            <Lottie
              animationData={successLottie}
              loop
            />
          </div>
          <div className="print-barcode__success-text">
            The barcodes for selected product are now ready.
            <div>
              <span onClick={() => {
                const data = `${printedBarcodes}`;
                const myWindow = window.open('', '_blank');
                myWindow.document.write(data);
              }}
              >
                Click here
              </span>
              &nbsp; to print the barcodes.
            </div>
          </div>
        </div>
      )}
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Generate Barcodes"
            onClick={() => onSubmit()}
            isLoading={printBarcodesLoading}
            disabled={printBarcodesLoading}
            style={{
              width: '160px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  printedBarcodes: ProductReducers.printedBarcodes,
  printBarcodesLoading: ProductReducers.printBarcodesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  printBarcodes: (payload, callback) => dispatch(ProductActions.printBarcodes(payload, callback)),
  printBarcodesSuccess: (printedBarcodes, callback) => dispatch(ProductActions.printBarcodesSuccess(printedBarcodes, callback)),
});

PrintBarcodes.propTypes = {
  history: PropTypes.func,
  printBarcodes: PropTypes.func,
  printBarcodesLoading: PropTypes.bool,
  selectedRows: PropTypes.any,
  printedBarcodes: PropTypes.string,
  printBarcodesSuccess: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrintBarcodes));
